/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(2);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _FsgoComponent = __webpack_require__(62);
	
	var _FsgoComponent2 = _interopRequireDefault(_FsgoComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderFsgo = function renderFsgo(id) {
		var mountNode = document.getElementById(id);
	
		if (mountNode) {
			performance.mark('fsgo[0]-render-start');
			var title = mountNode.getAttribute('title');
			var regionalIds = mountNode.getAttribute('regional-ids');
			var postType = mountNode.getAttribute('post-type');
			var videosItemSize = mountNode.getAttribute('videos-item-size');
			var isFifaWC = mountNode.getAttribute('fifa-wc');
			_reactDom2.default.render(_react2.default.createElement(_FsgoComponent2.default, { title: title,
				regionalIds: regionalIds,
				postType: postType,
				videosItemSize: videosItemSize,
				isFifaWC: isFifaWC === '1',
				componentId: 0 }), mountNode);
		}
	};
	
	var mountNodes = document.getElementsByTagName('Fsgo');
	
	if (mountNodes) {
		for (var i = 0; i < mountNodes.length; i++) {
			var mountNode = mountNodes[i];
			renderFsgo(mountNode.getAttribute('id'));
		}
	}
	
	window.renderFsgo = renderFsgo;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

	module.exports = React;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

	module.exports = ReactDOM;

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.get = get;
	exports.post = post;
	
	var _isomorphicFetch = __webpack_require__(6);
	
	var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);
	
	var _utils = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function fetchData(url, options, callback, error) {
		return (0, _isomorphicFetch2.default)(url, options).then(_utils.handleFetchedErrors).then(function (response) {
			return response.json();
		}).then(callback).catch(error);
	}
	
	function sendPost(url, options, callback, error) {
		return (0, _isomorphicFetch2.default)(url, options).then(_utils.handleFetchedErrors).then(callback).catch(error);
	}
	
	function get(url, callback, error) {
		var options = Object.assign({ method: 'GET' }, _utils.headers);
	
		return fetchData(url, options, callback, error);
	}
	
	function post(url, data, callback, error) {
		var customHeaders = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _utils.headers;
	
		var options = Object.assign({ method: 'POST', body: JSON.stringify(data) }, customHeaders);
		return sendPost(url, options, callback, error);
	}

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	// the whatwg-fetch polyfill installs the fetch() function
	// on the global object (window or self)
	//
	// Return that as the export for use in Webpack, Browserify etc.
	__webpack_require__(7);
	module.exports = self.fetch.bind(self);


/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.WHATWGFetch = {})));
	}(this, (function (exports) { 'use strict';
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob:
	      'FileReader' in self &&
	      'Blob' in self &&
	      (function() {
	        try {
	          new Blob();
	          return true
	        } catch (e) {
	          return false
	        }
	      })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  function isDataView(obj) {
	    return obj && DataView.prototype.isPrototypeOf(obj)
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isArrayBufferView =
	      ArrayBuffer.isView ||
	      function(obj) {
	        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	      };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue + ', ' + value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push(name);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) {
	      items.push(value);
	    });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) {
	      items.push([name, value]);
	    });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        this._bodyText = body = Object.prototype.toString.call(body);
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return methods.indexOf(upcased) > -1 ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      this.signal = input.signal;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'same-origin';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.signal = options.signal || this.signal;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, {body: this._bodyInit})
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body
	      .trim()
	      .split('&')
	      .forEach(function(bytes) {
	        if (bytes) {
	          var split = bytes.split('=');
	          var name = split.shift().replace(/\+/g, ' ');
	          var value = split.join('=').replace(/\+/g, ' ');
	          form.append(decodeURIComponent(name), decodeURIComponent(value));
	        }
	      });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  exports.DOMException = self.DOMException;
	  try {
	    new exports.DOMException();
	  } catch (err) {
	    exports.DOMException = function(message, name) {
	      this.message = message;
	      this.name = name;
	      var error = Error(message);
	      this.stack = error.stack;
	    };
	    exports.DOMException.prototype = Object.create(Error.prototype);
	    exports.DOMException.prototype.constructor = exports.DOMException;
	  }
	
	  function fetch(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	
	      if (request.signal && request.signal.aborted) {
	        return reject(new exports.DOMException('Aborted', 'AbortError'))
	      }
	
	      var xhr = new XMLHttpRequest();
	
	      function abortXhr() {
	        xhr.abort();
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.onabort = function() {
	        reject(new exports.DOMException('Aborted', 'AbortError'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      if (request.signal) {
	        request.signal.addEventListener('abort', abortXhr);
	
	        xhr.onreadystatechange = function() {
	          // DONE (success or failure)
	          if (xhr.readyState === 4) {
	            request.signal.removeEventListener('abort', abortXhr);
	          }
	        };
	      }
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  }
	
	  fetch.polyfill = true;
	
	  if (!self.fetch) {
	    self.fetch = fetch;
	    self.Headers = Headers;
	    self.Request = Request;
	    self.Response = Response;
	  }
	
	  exports.Headers = Headers;
	  exports.Request = Request;
	  exports.Response = Response;
	  exports.fetch = fetch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.isTabletOrMobile = exports.isFlashEnabled = exports.assetsDomain = exports.headers = undefined;
	exports.handleFetchedErrors = handleFetchedErrors;
	exports.getPostId = getPostId;
	exports.decodeText = decodeText;
	exports.decodeHtmlEntities = decodeHtmlEntities;
	exports.parseImagesTag = parseImagesTag;
	exports.parseSeconds = parseSeconds;
	exports.fbShareParselyTrackLink = fbShareParselyTrackLink;
	exports.getFbShareUrl = getFbShareUrl;
	exports.getQueryString = getQueryString;
	
	var _utils = __webpack_require__(9);
	
	var _TrackingUtils = __webpack_require__(10);
	
	var _TrackingUtils2 = _interopRequireDefault(_TrackingUtils);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var headers = exports.headers = {
		headers: {
			Accept: 'application/json',
			'Content-Type': 'application/json'
		},
		credentials: 'include'
	
	};
	
	function handleFetchedErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
	
		return response;
	}
	
	function getPostId() {
		var pageInfo = document.getElementById('page-information');
		if (pageInfo) {
			var body = document.querySelector('.fox_sectionfront .body-content');
			if (body) {
				return body.getAttribute('post-id');
			}
		}
	
		return document.body.getAttribute('post-id');
	}
	
	function getAssetsDomain() {
		var locationName = location.hostname;
	
		if (locationName.match(/www.foxsports.com/)) {
			return 'https://b.fssta.com/sta/';
		}
	
		if (locationName.match(/wp.foxsports.com/)) {
			return 'https://b.dev.fssta.com/sta/';
		}
	
		return '/wp-content/themes/foxsports/assets/dist/';
	}
	
	var assetsDomain = exports.assetsDomain = getAssetsDomain();
	
	function decodeText(text) {
		return text.replace(/\&#(\d*)\;/g, function (s) {
			return decodeTable[s] || '';
		});
	}
	
	function decodeHtmlEntities(text) {
		return text.replace(/\&(\w*|#\d*)\;/g, function (s) {
			return HTMLEntitiesTable[s] || '';
		});
	}
	
	var HTMLEntitiesTable = {
		'&amp;': '&',
		'&quot;': '"',
		'&#039;': "'",
		'&lt;': '<',
		'&gt;': '>'
	};
	
	var decodeTable = {
		'&#32;': ' ',
		'&#33;': '!',
		'&#34;': '"',
		'&#35;': '#',
		'&#36;': '$',
		'&#37;': '%',
		'&#38;': '&',
		'&#39;': '\'',
		'&#40;': '(',
		'&#41;': ')',
		'&#42;': '*',
		'&#43;': '+',
		'&#44;': ',',
		'&#45;': '-',
		'&#46;': '.',
		'&#47;': '/',
	
		'&#8211;': '–',
		'&#8212;': '—',
		'&#8216;': '‘',
		'&#8217;': '’',
		'&#8218;': '‚',
		'&#8220;': '“',
		'&#8221;': '”',
		'&#8222;': '„',
		'&#8224;': '†',
		'&#8225;': '‡',
		'&#8226;': '•',
		'&#8230;': '…',
		'&#8240;': '‰',
		'&#8364;': '€',
		'&#8482;': '™'
	};
	
	function parseImagesTag(text) {
		text = '<div>' + text + '</div>';
		var parser = new DOMParser();
	
		var result = {
			srcSet: '',
			sizes: '',
			src: '',
			noscript: ''
		};
	
		try {
			var el = parser.parseFromString(text, 'text/html');
			var images = el.getElementsByTagName('img');
	
			if (images.length > 0) {
				var img = images[0];
	
				result.sizes = img.getAttribute('data-sizes') || img.getAttribute('sizes');
				result.srcSet = img.getAttribute('data-srcset') || img.getAttribute('srcset');
				result.src = img.getAttribute('data-src') || img.getAttribute('src');
			}
	
			var noscripts = el.getElementsByTagName('noscript');
	
			if (noscripts.length > 0) {
				var noscript = noscripts[0];
	
				result.noscript = noscript.innerHTML;
			}
		} finally {
			return result;
		}
	}
	
	function parseSeconds(time) {
		if (!time || time.indexOf('.') === -1) {
			return time;
		}
	
		var minutes = Math.floor(time / 60);
		var seconds = Math.floor(time - minutes * 60);
	
		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}
	
	function isFlashEnabledFn() {
		var hasFlash = false;
	
		try {
			if (navigator.mimeTypes && navigator.mimeTypes['application/x-shockwave-flash'] ? navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin : 0) {
				hasFlash = true;
			}
		} catch (e) {
			if (navigator.mimeTypes['application/x-shockwave-flash'] != undefined) {
				hasFlash = true;
			}
		}
	
		return hasFlash;
	}
	
	var isFlashEnabled = exports.isFlashEnabled = isFlashEnabledFn();
	
	function isTabletOrMobileFn() {
		return navigator.userAgent.match(/Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini|Windows Phone/i);
	}
	
	var isTabletOrMobile = exports.isTabletOrMobile = isTabletOrMobileFn();
	
	function getUtmTerm() {
		var pageType = (0, _utils.getPageMeta)()['page_type'];
		return pageType == 'home' ? 'homepage' : pageType == 'section front' ? 'sf' : 'post';
	}
	
	var UTM_TERM = getUtmTerm();
	
	function fbShareParselyTrackLink(e) {
	
		var trackingObject = {
			'utm_campaign': 'share_buttons',
			'utm_source': 'share_fb',
			'utm_medium': 'fscom',
			'utm_content': 'original_share',
			'utm_term': UTM_TERM
		};
	
		_TrackingUtils2.default.ParselyTrackLink(e, trackingObject);
	}
	
	function getFbShareUrl(url) {
		var utmParam = 'utm_campaign=share_buttons&utm_medium=fscom&utm_content=return_visit&utm_term=' + UTM_TERM + '&utm_source=share_fb';
		var utmUrl = url + '?' + utmParam;
	
		return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(utmUrl);
	}
	
	/**
	 * Get the value of a querystring
	 * @param  {String} field The field to get the value of
	 * @param  {String} url   The URL to get the value from (optional)
	 * @return {String}       The field value
	 */
	function getQueryString(field, url) {
		var href = url ? url : window.location.href;
		var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
		var string = reg.exec(href);
		return string ? string[1] : null;
	}

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.getPageMeta = getPageMeta;
	/**
	 * get meta object from meta tag fs-prop="analytics" on the main article (first article on the 3things)
	 * @returns {object} Meta Object
	 */
	function getPageMeta() {
	
		var data = {};
		var metaEl = document.querySelector('[fs-prop="analytics"]');
		var attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category', 'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title', 'gallery-name', 'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name', 'build-version', 'page-attribute', 'testScorestripPosition'];
	
		/**
	  *  to enforce html semantic, we use dashes for property names.
	  *  We need to do the dashes replacement with underscore since
	  *  analytic script uses underscore in the properties
	  */
	
		if (metaEl) {
			for (var i = 0, l = attributes.length; i < l; i++) {
				var attr = attributes[i];
				var val = metaEl.getAttribute(attr);
	
				if (val != null) {
					attr = attr.indexOf('-') >= 0 ? attr.replace(/-/g, '_') : attr;
					data[attr] = val.trim();
				}
			}
		}
	
		return data;
	}

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var TrackingUtils = function () {
	    function TrackingUtils() {
	        _classCallCheck(this, TrackingUtils);
	
	        this.isLogEnabled = false;
	        this.isBB = this.bodySection ? this.bodySection.classList.contains('body-content-big-board') : false;
	        this.checkLogEnabled();
	    }
	
	    _createClass(TrackingUtils, [{
	        key: 'log',
	        value: function log(message) {
	            this.isLogEnabled && console.log(message);
	        }
	    }, {
	        key: 'checkLogEnabled',
	        value: function checkLogEnabled() {
	            this.isLogEnabled = location.href.indexOf('trackinglog=true') > -1 ? true : false;
	        }
	
	        /**
	         * set tracking for link element
	         * @param {*} links
	         * @param {*} service
	         * @param {*} trackingObj
	         *     Example:
	         *        TrackingUtils.setLinkTracking(document.querySelectorAll('.more-video > a.fs-more-btn'),'parsely',{
	         *            'utm_campaign'  : 'more_videos',
	         *            'utm_medium'    : 'fscom',
	         *            'utm_content'   : 'morelink'
	         *        });
	         */
	
	    }, {
	        key: 'setLinkTracking',
	        value: function setLinkTracking(links, service, trackingObj) {
	            var _this = this;
	
	            if (!links || !links.length || !service) return;
	
	            if (links.constructor.name === 'NodeList') {
	                links = [].concat(_toConsumableArray(links));
	            }
	
	            for (var i = 0, lLen = links.length; i < lLen; i++) {
	                var link = links[i];
	                if (link.hasAttribute('data-link-tracked-by')) break;
	
	                if ('parsely' === service) {
	                    link.addEventListener('click', function (e) {
	                        _this.ParselyTrackLink(e, trackingObj);
	                    });
	                }
	                link.setAttribute('data-link-tracked-by', service);
	            }
	        }
	
	        /**
	         * add to target's event.addEventListener
	         * @param {*} ev
	        * @param trackingObj
	         */
	
	    }, {
	        key: 'ParselyTrackLink',
	        value: function ParselyTrackLink(ev, trackingObj) {
	            if (ev.preventDefault) ev.preventDefault();
	
	            var target = ev.currentTarget || ev.target;
	            var url = target.getAttribute('href');
	            var urlToTrack = target.getAttribute('data-url-to-track');
	
	            if (typeof PARSELY !== "undefined" && _typeof(PARSELY.beacon) === "object" && typeof PARSELY.beacon.trackPageView === 'function') {
	                var parselyObj = {
	                    'url': this.addTrackingQuery(trackingObj, urlToTrack || url),
	                    'js': 1
	                };
	
	                PARSELY.beacon.trackPageView(parselyObj);
	            }
	
	            window.open(url, target.getAttribute('target') || '_self');
	        }
	
	        /**
	         * constructing url param by using JS object (wrapping function)
	         * @param {*} trackingObj
	         * @param {*} url
	         */
	
	    }, {
	        key: 'addTrackingQuery',
	        value: function addTrackingQuery(trackingObj, url) {
	            for (var i in trackingObj) {
	                var val = trackingObj[i];
	                if (val) {
	                    url = this.updateQueryStringParam(url, i, val);
	                }
	            }
	            return url;
	        }
	
	        /**
	         * constructing url param by using JS object (actual logic)
	         * based on "https://stackoverflow.com/a/6021027"
	         * @param {*} uri
	         * @param {*} key
	         * @param {*} value
	         */
	
	    }, {
	        key: 'updateQueryStringParam',
	        value: function updateQueryStringParam(uri, key, value) {
	            var re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");
	            if (uri.match(re)) {
	                return uri.replace(re, '$1' + key + "=" + value + '$2');
	            } else {
	                var hash = '';
	                if (uri.indexOf('#') !== -1) {
	                    hash = uri.replace(/.*#/, '#');
	                    uri = uri.replace(/#.*/, '');
	                }
	                var separator = uri.indexOf('?') !== -1 ? "&" : "?";
	                return uri + separator + key + "=" + value + hash;
	            }
	        }
	
	        /**
	         * Replace empty spaces with dashes
	         * @param {string} str
	         */
	
	    }, {
	        key: 'replaceSpacesWithDash',
	        value: function replaceSpacesWithDash(str) {
	            return str.replace(/ /g, "-");
	        }
	
	        /**
	         * get vide title, image and section from video player info
	         * @returns Object {{title: string, image_url: string}}
	         */
	
	    }, {
	        key: 'getTrackingMeta',
	        value: function getTrackingMeta(player) {
	
	            var title = '';
	            var thumbnail = '';
	            var section = '';
	            var id = '';
	            var url = '';
	
	            if (typeof player.videoinfo.thumbnail !== "undefined") {
	                thumbnail = player.videoinfo.thumbnail;
	            }
	
	            if (typeof player.videoinfo.title !== "undefined") {
	                title = player.videoinfo.title;
	            }
	
	            if (typeof player.videoinfo.primary !== "undefined") {
	                section = player.videoinfo.primary;
	            }
	
	            if (typeof player.videoinfo.id !== "undefined") {
	                id = player.videoinfo.id;
	            }
	
	            if (typeof player.url !== "undefined") {
	                url = player.url;
	            }
	
	            return {
	                title: title,
	                image_url: thumbnail,
	                section: section,
	                id: id,
	                url: url
	            };
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart and OnMediaUnpause events
	         * @param isAd True or False for e.data.baseClip.isAd that is passed from player OnMediaStart and OnMediaUnpause events
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'sendPlay',
	        value: function sendPlay(isAd, player, utmObj) {
	            //only send parsely tracking on video play when the video clip is not an ad
	            if (!isAd) {
	                var metadata = this.getTrackingMeta(player);
	                this.sendTracking("play", metadata, utmObj);
	            }
	
	            return this;
	        }
	
	        /**
	         * @desc event triggered on player OnMediaStart event
	         * @returns {FsVideo}
	         */
	
	    }, {
	        key: 'sendPause',
	        value: function sendPause(isAd, player, utmObj) {
	
	            this.isPlaying = false;
	            this.isPaused = true;
	
	            //only send parsely tracking on video pause when the video clip is not an ad
	            if (!isAd) {
	                var metadata = this.getTrackingMeta(player);
	                this.sendTracking("pause", metadata, utmObj);
	            }
	
	            return this;
	        }
	
	        /**
	         * @desc Send parsely tracking when video is played or paused
	         * parsely doc: https://www.parsely.com/help/integration/video/
	         * @param type
	         * @param metadata
	         * @param utmObj
	         */
	
	    }, {
	        key: 'sendTracking',
	        value: function sendTracking(type, metadata, utmObj) {
	
	            //if only send parsely tracking when there is video ID and PARSELY is available
	            var isParsely = typeof PARSELY !== 'undefined' && _typeof(PARSELY.video) === 'object';
	            if (typeof metadata !== "undefined" && metadata.id !== "undefined" && isParsely) {
	
	                /**
	                 * we only include title, image_url and section for tracking
	                 * We don't have pub_date_tmsp, tags and authors from the video player info.
	                 * We can get them, but it will require additional server call for the videos,
	                 * so we skip including them at this moment
	                 */
	                var urlOverride = metadata.url !== '' ? metadata.url : location.origin + location.pathname;
	                //let metadata = this.getTrackingMeta();
	
	                metadata.section = utmObj.utm_content || utmObj.utm_section;
	                urlOverride = this.addTrackingQuery(utmObj, urlOverride);
	
	                //the following log info for debugging purpose on the console. We will remove it when we release it to prod
	                this.log('\n                    VIDEO TRACKING: sending parsely data\n                    type: ' + type + '\n                    title: ' + metadata.title + '\n                    thumbnail: ' + metadata.image_url + '\n                    vid: ' + metadata.id + '\n                    urlOverride: ' + urlOverride + '\n                    config: ' + JSON.stringify(metadata) + ' \n            ');
	
	                try {
	                    if (type === 'play') {
	                        PARSELY.video.trackPlay(metadata.id, metadata, urlOverride);
	                    } else if (type === 'pause') {
	                        PARSELY.video.trackPause(metadata.id, metadata, urlOverride);
	                    } else {
	                        console.log("Tracking Type Not Supported", type);
	                    }
	                } catch (err) {
	                    console.log("Error sending tracking info: ", err);
	                }
	            }
	        }
	
	        /**
	         * @desc replace string to a slug-like format
	         * @returns String
	         * i.e., "This Is A Slug!" = "this-is-a-slug"
	         */
	
	    }, {
	        key: 'formatStringAsSlug',
	        value: function formatStringAsSlug(str) {
	            return str.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
	        }
	
	        /**
	         * It is trackable for page view if it is on section front page and the video config include video id in url
	         * @param string videoId 
	         * @param string currentUrl
	         * @returns {boolean} 
	         */
	
	    }, {
	        key: 'isTrackable',
	        value: function isTrackable(videoId, currentUrl) {
	            //return true if id from url match the current url id does not match
	            return '' !== videoId && currentUrl.substr(currentUrl.lastIndexOf('/') + 1) !== videoId;
	        }
	
	        /**
	         * format object for UTM tracking use
	         * @param {obj} unformatted utm object
	         */
	
	    }, {
	        key: 'getUtmObj',
	        value: function getUtmObj(obj) {
	            var result = {};
	            // loop through object and reformatting property names for UTM tracking
	            for (var item in obj) {
	                switch (item) {
	                    case "campaign":
	                    case "section":
	                    case "source":
	                    case "medium":
	                    case "content":
	                    case "term":
	                        result["utm_" + item] = obj[item];
	                        break;
	                    default:
	                        break;
	                }
	            }
	            // failover check for "utm_campaign" and "utm_medium"
	            result["utm_campaign"] = result["utm_campaign"] || "video_playback_location";
	            if (typeof result["utm_medium"] === 'undefined') {
	                if (typeof this.isBB !== 'undefined') {
	                    this.isSectionFront = document.body.classList.contains('single-fox_sectionfront');
	                    this.isMediaHub = document.body.classList.contains('single-fox_media_hub');
	                    this.isBB = this.bodySection ? this.bodySection.classList.contains('body-content-big-board') : false;
	                }
	                result["utm_medium"] = this.isBB ? 'bb_video_player' : 'video_player';
	            }
	            return result;
	        }
	
	        /**
	         * Gets utm params based on the Page Name property from the video config object
	         * Format for the page name params is i.e fscom:nfl:section-front:featured-content
	         * [0] = site
	         * [1] = section/category - (utm_content)
	         * [2] = page type - (utm_source)
	         * [3] = term - (utm_term)
	         * @param {string} pageName
	         */
	
	    }, {
	        key: 'getUtmParams',
	        value: function getUtmParams(pageName) {
	            pageName.split(':');
	            return {
	                site: pageName[0] || '',
	                section: pageName[1] || '',
	                source: pageName[2] || '',
	                term: pageName[3] || ''
	            };
	        }
	        /**
	         * get embed utm params
	         * @param {*} isAmp 
	         * @param {*} category 
	         */
	
	    }, {
	        key: 'getEmbedUtmParams',
	        value: function getEmbedUtmParams(isAmp, category) {
	            return this.getUtmObj({
	                'medium': isAmp ? "amp_video_player" : "embed_video_player",
	                'source': 'embed-video-page',
	                'content': category,
	                'term': ''
	            });
	        }
	    }]);
	
	    return TrackingUtils;
	}();
	
	exports.default = new TrackingUtils();

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FsgoItems = __webpack_require__(63);
	
	var _FsgoItems2 = _interopRequireDefault(_FsgoItems);
	
	var _FsgoVideosService = __webpack_require__(66);
	
	var _FsgoVideosService2 = _interopRequireDefault(_FsgoVideosService);
	
	var _constants = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Fsgo = function (_React$Component) {
	    _inherits(Fsgo, _React$Component);
	
	    function Fsgo(props) {
	        _classCallCheck(this, Fsgo);
	
	        var _this = _possibleConstructorReturn(this, (Fsgo.__proto__ || Object.getPrototypeOf(Fsgo)).call(this, props));
	
	        _this.state = {
	            isDataFetched: false,
	            isLoggedIn: false,
	            mvpdLogoUrl: ''
	        };
	        return _this;
	    }
	
	    _createClass(Fsgo, [{
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            performance.mark('fsgo[' + this.props.componentId + ']-componentWillMount');
	        }
	    }, {
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            performance.mark('fsgo[' + this.props.componentId + ']-componentDidUpdate');
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            performance.mark('fsgo[' + this.props.componentId + ']-componentDidMount');
	            performance.mark('fsgo[' + this.props.componentId + ']-getVideos');
	
	            _FsgoVideosService2.default.getVideos(this.props).then(function (videos) {
	                performance.mark('fsgo[' + _this2.props.componentId + ']-setState');
	                _this2.setState(function () {
	                    return {
	                        isDataFetched: true,
	                        allLiveVideosCount: videos.allLiveVideosCount,
	                        liveVideos: videos.liveVideos,
	                        featureVideos: videos.featureVideos,
	                        liveMatchVideos: videos.liveMatchVideos,
	                        featuredMatchVideos: videos.featuredMatchVideos,
	                        regionNames: videos.regionNames
	                    };
	                });
	            });
	
	            _FsgoVideosService2.default.getAuthStatus().then(function (status) {
	                _this2.setState(function () {
	                    return {
	                        isLoggedIn: status.isLoggedIn,
	                        mvpdLogoUrl: status.mvpdLogoUrl
	                    };
	                });
	            });
	        }
	    }, {
	        key: 'getContainerClass',
	        value: function getContainerClass() {
	            if (this.props.title || this.props.isFifaWC) {
	                return '';
	            }
	
	            if (_FsgoVideosService2.default.isViewAllSeparatorShown(this.state.regionNames, true)) {
	                return 'align-videos';
	            }
	
	            return 'align-title';
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            if (!this.state.isDataFetched) return null;
	
	            var isVideosAvailable = this.state.liveVideos.length > 0 || this.state.featureVideos.length > 0;
	            var isFifaWCMatchVideosAvailable = this.props.isFifaWC && (this.state.liveMatchVideos.length > 0 || this.state.featuredMatchVideos.length > 0);
	            var isFSGOShown = isVideosAvailable || isFifaWCMatchVideosAvailable;
	
	            if (!isFSGOShown) return null;
	
	            var isFifaWCShown = this.props.isFifaWC && isVideosAvailable;
	            var isFifaWCMatchesShown = this.props.isSE && isFifaWCMatchVideosAvailable;
	
	            return _react2.default.createElement(
	                'div',
	                { className: this.getContainerClass() },
	                this.props.title && !this.props.isFifaWC && _react2.default.createElement(
	                    'div',
	                    { className: 'fsgo-title-container' },
	                    _react2.default.createElement(
	                        'h3',
	                        { className: 'sidebar-component-title' },
	                        this.props.title
	                    ),
	                    _react2.default.createElement('span', { className: 'separator' })
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'fs-go-sidebar-container' },
	                    _react2.default.createElement(
	                        'ul',
	                        { className: 'tune-in-list' },
	                        isFifaWCMatchesShown && _react2.default.createElement(_FsgoItems2.default, { items: this.state.liveMatchVideos,
	                            state: 'live',
	                            title: 'MATCHES',
	                            isPost: this.props.postType !== _constants.settings.SF_POST_TYPE,
	                            postType: this.props.postType,
	                            isFifaWC: this.props.isFifaWC,
	                            isSE: this.props.isSE,
	                            isMatches: true,
	                            isLoggedIn: this.state.isLoggedIn,
	                            regionNames: this.state.regionNames }),
	                        isFifaWCMatchesShown && this.state.featuredMatchVideos.length > 0 && _react2.default.createElement(_FsgoItems2.default, { items: this.state.featuredMatchVideos,
	                            state: 'featured',
	                            title: '',
	                            isPost: this.props.postType !== _constants.settings.SF_POST_TYPE,
	                            postType: this.props.postType,
	                            isFifaWC: this.props.isFifaWC,
	                            isWatchReplay: true,
	                            isSE: this.props.isSE,
	                            isLoggedIn: this.state.isLoggedIn,
	                            regionNames: this.state.regionNames }),
	                        (this.state.liveVideos.length > 0 || isFifaWCShown) && _react2.default.createElement(_FsgoItems2.default, { items: this.state.liveVideos,
	                            state: 'live',
	                            title: this.props.isFifaWC ? this.props.isSE ? 'TUNE IN' : 'TV COVERAGE' : 'LIVE NOW',
	                            isPost: this.props.postType !== _constants.settings.SF_POST_TYPE,
	                            postType: this.props.postType,
	                            isFifaWC: this.props.isFifaWC,
	                            isFifaWCMatchesShown: isFifaWCMatchesShown,
	                            isSE: this.props.isSE,
	                            regionNames: this.state.regionNames,
	                            isLoggedIn: this.state.isLoggedIn,
	                            allCount: this.state.allLiveVideosCount }),
	                        this.state.featureVideos.length > 0 && _react2.default.createElement(_FsgoItems2.default, { items: this.state.featureVideos,
	                            state: 'featured',
	                            title: this.props.isFifaWC ? '' : 'FEATURED',
	                            isPost: this.props.postType !== _constants.settings.SF_POST_TYPE,
	                            postType: this.props.postType,
	                            isFifaWC: this.props.isFifaWC,
	                            isLoggedIn: this.state.isLoggedIn,
	                            regionNames: this.state.regionNames })
	                    ),
	                    this.state.isLoggedIn && this.state.mvpdLogoUrl && _react2.default.createElement(
	                        'div',
	                        { className: 'channel-logo-container' },
	                        _react2.default.createElement('img', { className: 'channel-logo-img', src: this.state.mvpdLogoUrl })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Fsgo;
	}(_react2.default.Component);
	
	exports.default = Fsgo;

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FsgoItem = __webpack_require__(64);
	
	var _FsgoItem2 = _interopRequireDefault(_FsgoItem);
	
	var _FsgoVideosService = __webpack_require__(66);
	
	var _FsgoVideosService2 = _interopRequireDefault(_FsgoVideosService);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FsgoItems = function (_React$Component) {
		_inherits(FsgoItems, _React$Component);
	
		function FsgoItems(props) {
			_classCallCheck(this, FsgoItems);
	
			return _possibleConstructorReturn(this, (FsgoItems.__proto__ || Object.getPrototypeOf(FsgoItems)).call(this, props));
		}
	
		_createClass(FsgoItems, [{
			key: 'isSeparatorShown',
			value: function isSeparatorShown() {
				var isLive = this.props.state === 'live';
	
				if (this.props.isFifaWC) return isLive;
	
				return _FsgoVideosService2.default.isViewAllSeparatorShown(this.props.regionNames, isLive);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var title = this.props.title;
				var state = this.props.state;
				var isLive = state === 'live';
				var videos = this.props.items;
				var allCount = this.props.allCount;
				var regionNames = this.props.regionNames;
				var isFifaWC = this.props.isFifaWC;
				var isMatches = this.props.isMatches;
				var isSeparatorShown = this.isSeparatorShown();
				var isViewAllShown = !this.props.isSE && (isFifaWC && isLive || !isLive || videos.length !== allCount);
				var fifaWcClass = isFifaWC ? 'fifa-wc' : '';
	
				if (this.props.isFifaWCMatchesShown) fifaWcClass += ' fifa-wc-matches-shown';
	
				var idx = 1;
				var itemKey = 1;
				var regionKey = 1;
	
				return _react2.default.createElement(
					'li',
					{ className: 'tune-in-item' },
					_react2.default.createElement(
						'div',
						{ className: 'tune-in-item-container' },
						_react2.default.createElement(
							'div',
							{ className: state },
							(!isFifaWC || isLive || isMatches) && _react2.default.createElement(
								'div',
								{ className: 'title ' + fifaWcClass },
								_react2.default.createElement(
									'div',
									{ className: !isSeparatorShown ? 'text-block' : '' },
									_react2.default.createElement(
										'span',
										{ className: isSeparatorShown && regionNames.length > 0 ? 'title-block' : '' },
										title
									),
									regionNames.map(function (n) {
										return _react2.default.createElement(
											'span',
											{ className: 'region-name', key: regionKey++ },
											n
										);
									}),
									isSeparatorShown && isViewAllShown && _react2.default.createElement('span', { className: 'view-all-separator' }),
									isViewAllShown && _react2.default.createElement(
										'a',
										{ className: 'view-all ' + state + ' ' + fifaWcClass,
											target: '_blank',
											href: 'https://www.foxsportsgo.com/' },
										isLive && !isFifaWC ? 'View All (' + allCount + ')' : 'Full Listings'
									)
								)
							),
							videos.length > 0 && _react2.default.createElement(
								'div',
								{ className: 'content ' + fifaWcClass + ' ' + (isMatches ? 'matches' : '') },
								_react2.default.createElement(
									'ul',
									{ className: 'videos' },
									videos.map(function (v) {
										return _react2.default.createElement(_FsgoItem2.default, { item: v,
											state: state,
											isPost: _this2.props.isPost,
											postType: _this2.props.postType,
											isLoggedIn: _this2.props.isLoggedIn,
											isFifaWC: isFifaWC,
											isWatchReplay: _this2.props.isWatchReplay,
											key: itemKey++,
											idx: idx++ });
									})
								)
							)
						)
					)
				);
			}
		}]);
	
		return FsgoItems;
	}(_react2.default.Component);
	
	exports.default = FsgoItems;

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _constants = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FsgoItem = function (_React$Component) {
		_inherits(FsgoItem, _React$Component);
	
		function FsgoItem(props) {
			_classCallCheck(this, FsgoItem);
	
			return _possibleConstructorReturn(this, (FsgoItem.__proto__ || Object.getPrototypeOf(FsgoItem)).call(this, props));
		}
	
		_createClass(FsgoItem, [{
			key: 'handleClick',
			value: function handleClick() {
				var props = {
					postType: this.props.postType,
					content: this.props.state
				};
				FsBeacon.EpgTracking(props).fire();
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var state = this.props.state;
				var idx = this.props.idx;
				var isLive = state === 'live';
				var v = this.props.item;
				var isFifaWC = this.props.isFifaWC;
				var isMobileStreamingAllowed = v.tag !== _constants.settings.NOT_ALLOWED_MOBILE_STREAMING_TAG;
				var imageClassName = 'video-img ' + (this.props.isPost ? 'at-post' : '');
				var videoDescClassName = 'video-desc ' + (this.props.isPost ? 'at-post' : '');
	
				return _react2.default.createElement(
					'li',
					{ className: 'video-list ' + state + ' ' + (isFifaWC ? 'fifa-wc' : ''), onClick: function onClick() {
							return _this2.handleClick();
						} },
					_react2.default.createElement(
						'a',
						{ href: v.url,
							id: 'tune-in-video-' + state + '-' + idx,
							target: '_blank',
							className: 'video-link ' + (!isMobileStreamingAllowed ? 'disable-link' : '') },
						_react2.default.createElement(
							'figure',
							{ className: 'video-thumbnail' },
							_react2.default.createElement(
								'div',
								{ className: 'img-wrap' },
								_react2.default.createElement('img', { className: imageClassName + (v.resizedImageUrlSmall ? ' hide-on-small' : '') + ' lazyload',
									alt: v.title,
									'data-src': v.resizedImageUrl,
									'data-srcset': v.resizedImageUrl }),
								v.resizedImageUrlSmall && _react2.default.createElement('img', { className: imageClassName + ' hide-on-large lazyload',
									alt: v.title,
									'data-src': v.resizedImageUrlSmall,
									'data-srcset': v.resizedImageUrlSmall })
							),
							_react2.default.createElement(
								'div',
								{ className: 'channel-container ' + (v.channelDescription || '').toLowerCase() },
								isLive && v.tag && !isFifaWC && _react2.default.createElement(
									'div',
									{ className: 'channel-desc' },
									v.tag
								),
								!(v.isReplay && this.props.isWatchReplay) && _react2.default.createElement(
									'div',
									{ className: 'channel-desc' },
									v.channelDescription
								)
							),
							isLive && _react2.default.createElement('div', { className: 'gradient-overlay' })
						),
						_react2.default.createElement(
							'div',
							{ className: videoDescClassName },
							isLive && !this.props.isLoggedIn && _react2.default.createElement(
								'div',
								{ className: 'key-icon-container' },
								_react2.default.createElement('span', { className: 'key-icon' })
							),
							isLive ? _react2.default.createElement(
								'div',
								{ className: 'live-time-wrapper' },
								_react2.default.createElement('span', { className: 'state' })
							) : _react2.default.createElement(
								'span',
								{ className: 'state' },
								(this.props.isWatchReplay && v.isReplay ? 'Watch Replay' : v.formattedStartTime) + ' ',
								!this.props.isLoggedIn && _react2.default.createElement('span', { className: 'key-icon' })
							),
							_react2.default.createElement(
								'span',
								{ className: 'desc' },
								v.title
							),
							v.isReplay && !this.props.isWatchReplay && _react2.default.createElement(
								'span',
								{ className: 'replay' },
								' RE-AIR '
							)
						),
						!isMobileStreamingAllowed && _react2.default.createElement(
							'div',
							{ className: 'availability-alert' },
							_react2.default.createElement(
								'div',
								{ className: 'alert-title' },
								'Available on'
							),
							_react2.default.createElement(
								'div',
								{ className: 'alert-devices' },
								'Tablet, Computer & Connected Devices'
							)
						)
					)
				);
			}
		}]);
	
		return FsgoItem;
	}(_react2.default.Component);
	
	exports.default = FsgoItem;

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var settings = exports.settings = {
		PROGS_URL: '/wp-json/fsgo/prog',
		NOT_ALLOWED_MOBILE_STREAMING_TAG: 0,
		SF_POST_TYPE: 'fox_sectionfront',
		REGIONAL_SF: 'r_sf',
		REGIONAL_POST: 'r_p',
		NATIONAL_SF: 'n_sf',
		NATIONAL_POST: 'n_p'
	};

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(65);
	
	var _FetchService = __webpack_require__(5);
	
	var _EsiGeo = __webpack_require__(67);
	
	var _EsiGeo2 = _interopRequireDefault(_EsiGeo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Videos = function Videos() {
		_classCallCheck(this, Videos);
	
		this.liveVideos = [];
		this.featureVideos = [];
		this.allLiveVideosCount = 0;
	};
	
	var FsgoVideosServices = function () {
		function FsgoVideosServices() {
			_classCallCheck(this, FsgoVideosServices);
	
			this.getVideosProm = {};
		}
	
		_createClass(FsgoVideosServices, [{
			key: 'getVideos',
			value: function getVideos(data) {
				var seQueryParams = '';
				var promName = data.isFifaWC ? 'fifaWC' : data.regionalIds || 'zip';
				if (data.isSE) {
					var wcDay = this.getParameterByName('wc_day');
					var wcHour = this.getParameterByName('wc_hour');
	
					if (wcDay) seQueryParams += '&wc_day=' + wcDay;
					if (wcHour) seQueryParams += '&wc_hour=' + wcHour;
	
					promName += 'se' + seQueryParams;
				}
	
				if (this.getVideosProm[promName]) {
					return this.getVideosProm[promName];
				}
	
				var isSF = data.postType === _constants.settings.SF_POST_TYPE;
	
				var zip = data.isFifaWC ? '' : this.getParameterByName('zip') || _EsiGeo2.default.zip || '';
	
				var queryParams = data.regionalIds ? 'ids=' + data.regionalIds + '&type=' + (isSF ? _constants.settings.REGIONAL_SF : _constants.settings.REGIONAL_POST) : 'zip=' + zip + '&type=' + (isSF ? _constants.settings.NATIONAL_SF : _constants.settings.NATIONAL_POST);
	
				queryParams += '&size=' + (data.videosItemSize || '0');
	
				if (data.isFifaWC) queryParams += '&wc=1';
				if (data.isSE) queryParams += '&se=1' + seQueryParams;
	
				queryParams += this.getTimeMockParams();
	
				this.getVideosProm[promName] = (0, _FetchService.get)(_constants.settings.PROGS_URL + '?' + queryParams, function (json) {
					var result = new Videos();
	
					result.allLiveVideosCount = json.live.allCount;
					result.regionNames = json.regionNames;
					result.liveVideos = getItemsFromProg(json.live);
					result.featureVideos = getItemsFromProg(json.featured);
					result.liveMatchVideos = getItemsFromProg(json.liveMatches);
					result.featuredMatchVideos = getItemsFromProg(json.featuredMatches);
	
					return result;
				}, function () {
					return new Videos();
				});
	
				return this.getVideosProm[promName];
			}
		}, {
			key: 'getTimeMockParams',
			value: function getTimeMockParams() {
				var result = '';
	
				var start = this.getParameterByName('start');
				var end = this.getParameterByName('end');
				var now = this.getParameterByName('now');
	
				if (start) result += '&start=' + start;
				if (end) result += '&end=' + end;
				if (now) result += '&now=' + now;
	
				return result;
			}
		}, {
			key: 'getAuthStatus',
			value: function getAuthStatus() {
				return new Promise(function (resolve, reject) {
					if (!window.bamtechAuthReady) {
						resolve({});
						return;
					}
	
					window.bamtechAuthReady.then(function (status) {
						return resolve(status);
					});
				});
			}
		}, {
			key: 'isViewAllSeparatorShown',
			value: function isViewAllSeparatorShown(regionNames, isLive) {
				if (!regionNames || regionNames.length === 0) {
					return true;
				}
	
				if (regionNames.length === 1 && regionNames[0].length < (isLive ? 21 : 27)) {
					return true;
				}
	
				return false;
			}
		}, {
			key: 'getParameterByName',
			value: function getParameterByName(name, url) {
				if (!url) url = window.location.href;
				name = name.replace(/[\[\]]/g, '\\$&');
				var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
				    results = regex.exec(url);
				if (!results) return null;
				if (!results[2]) return '';
				return decodeURIComponent(results[2].replace(/\+/g, ' '));
			}
		}]);
	
		return FsgoVideosServices;
	}();
	
	function getItemsFromProg(prog) {
		if (prog && prog.count > 0) {
			return prog.items || [];
		}
	
		return [];
	}
	
	exports.default = new FsgoVideosServices();

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EsiGeo = function () {
	  function EsiGeo() {
	    _classCallCheck(this, EsiGeo);
	
	    var zip = this.getValueById('esi_geo_zip');
	    this.zip = zip ? zip.substring(0, 5) : null;
	    this.dma = this.getValueById('esi_geo_dma') || '';
	    this.asnum = this.getValueById('esi_geo_asnum') || '';
	    this.nielsonDMACodes = {
	      524: 'ATLANTA',
	      520: 'AUGUSTA',
	      635: 'AUSTIN',
	      800: 'BAKERSFIELD',
	      716: 'BATON ROUGE',
	      746: 'BILOXI',
	      630: 'BIRMINGHAM',
	      648: 'CHAMPAIGN-SPRNGFLD-DECATUR',
	      519: 'CHARLESTON',
	      517: 'CHARLOTTE',
	      575: 'CHATTANOOGA',
	      602: 'CHICAGO',
	      510: 'CLEVELAND',
	      546: 'COLUMBIA',
	      522: 'COLUMBUS, GA',
	      535: 'COLUMBUS, OH',
	      600: 'CORPUS CHRISTI',
	      623: 'DALLAS-FT WORTH',
	      542: 'DAYTON',
	      505: 'DETROIT',
	      765: 'EL PASO',
	      513: 'FLINT-SAGINAW-BAY CITY',
	      866: 'FRESNO-VISALIA',
	      670: 'FT SMITH',
	      592: 'GAINESVILLE',
	      563: 'GRAND RAPIDS-KALMZOO-B CRK',
	      658: 'GREEN BAY-APPLETON',
	      518: 'GREENSBORO, NC',
	      567: 'GREENVILLE, SC',
	      636: 'HARLINGEN-MCALLEN',
	      618: 'HOUSTON',
	      691: 'HUNTSVILLE',
	      527: 'INDIANAPOLIS',
	      718: 'JACKSON, MS',
	      561: 'JACKSONVILLE',
	      616: 'KANSAS CITY',
	      557: 'KNOXVILLE, TN',
	      642: 'LAFAYETTE',
	      551: 'LANSING',
	      693: 'LITTLE ROCK-PINE BLUFF',
	      803: 'LOS ANGELES',
	      529: 'LOUISVILLE',
	      651: 'LUBBOCK',
	      669: 'MADISON',
	      640: 'MEMPHIS',
	      528: 'MIAMI-FT. LAUDERDALE',
	      617: 'MILWAUKEE',
	      686: 'MOBILE',
	      828: 'MONTEREY-SALINAS',
	      698: 'MONTGOMERY-SELMA',
	      659: 'NASHVILLE',
	      622: 'NEW ORLEANS, LA',
	      633: 'ODESSA-MIDLAND',
	      650: 'OKLAHOMA CITY',
	      534: 'ORLANDO-DAYTONA BCH-MELBRN',
	      656: 'PANAMA CITY',
	      560: 'RALEIGH-DURHAM (FAYETVLLE)',
	      811: 'RENO',
	      862: 'SACRAMNTO-STKTN-MODESTO',
	      641: 'SAN ANTONIO',
	      825: 'SAN DIEGO',
	      807: 'SAN FRANCISCO-OAK-SAN JOSE',
	      612: 'SHREVEPORT',
	      588: 'SOUTH BEND-ELKHART',
	      619: 'SPRINGFIELD MO',
	      609: 'ST LOUIS',
	      547: 'TOLEDO',
	      605: 'TOPEKA',
	      671: 'TULSA',
	      548: 'WEST PALM BEACH',
	      678: 'WICHITA-HUTCHINSON PLUS',
	      550: 'WILMINGTON'
	    };
	  }
	
	  _createClass(EsiGeo, [{
	    key: 'getValueById',
	    value: function getValueById(id) {
	      var element = document.getElementById(id);
	
	      if (!element || !element.innerHTML || element.innerHTML[0] === '$') return null;
	
	      return element.innerHTML;
	    }
	  }]);
	
	  return EsiGeo;
	}();
	
	exports.default = new EsiGeo();

/***/ })

/******/ });


// WEBPACK FOOTER //
// assets/dist/js/react/fsgo.min.js